export default "__VITE_ASSET__BrfAgOeq__"